var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.userId !== undefined && _vm.userId !== null
    ? _c("span", {
        class: ["like-icon", { liked: _vm.isFavored }],
        attrs: { "data-like-icon": "" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.processLikeClicked.apply(null, arguments)
          },
        },
      })
    : _c("span", {
        staticClass: "like-icon",
        attrs: {
          "data-like-icon": "",
          "data-toggle": "modal",
          "data-target": "#registerFavorite",
          "data-select-load-recaptcha": "",
          "data-load-url": _vm.favouriteLink,
        },
        on: {
          click: function ($event) {
            $event.preventDefault()
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }